"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _reduxObservable = require("redux-observable");

var _UpdateMarketingFreeSettings = _interopRequireDefault(require("settings-ui-modules/marketing/modules/collected-forms/stagedObjects/UpdateMarketingFreeSettings"));

var _epic = _interopRequireDefault(require("settings-ui-sdk/MarketingFreeSettings/epic"));

var _default = (0, _reduxObservable.combineEpics)(_epic.default, _UpdateMarketingFreeSettings.default.getResetChangesToStagedObjectEpic());

exports.default = _default;
module.exports = exports.default;